import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},_vm._l((_vm.done_groups),function(group,idx){return _c('group-card',{key:group.id,staticClass:"mb-3",attrs:{"group":group}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }